import { render } from "./SaveToCollectionChooserBody.vue.js?vue&type=template&id=c7ca4640!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SaveToCollectionChooserBody.vue?vue&type=template&id=c7ca4640"
import script from "./SaveToCollectionChooserBody.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SaveToCollectionChooserBody.vue?vue&type=script&lang=js"
export * from "./SaveToCollectionChooserBody.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SaveToCollectionChooserBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/saved-posts/SaveToCollectionChooserBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7ca4640"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7ca4640', __exports__)) {
    api.reload('c7ca4640', __exports__)
  }
  
  module.hot.accept("./SaveToCollectionChooserBody.vue.js?vue&type=template&id=c7ca4640!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SaveToCollectionChooserBody.vue?vue&type=template&id=c7ca4640", () => {
    api.rerender('c7ca4640', render)
  })

}


export default __exports__